import { Navigate, RouteObject } from 'react-router-dom';

export const trackEditorRoutes: RouteObject[] = [
  {
    index: true,
    lazy: () => import('./pages/update-track/UpdateTrackPage').then(m => ({ Component: m.UpdateTrackPage })),
  },

  {
    path: 'challenges/create',
    lazy: () =>
      import('./pages/manage-challenge/ManageChallengePage').then(m => ({ Component: m.ManageChallengePage })),
  },
  {
    path: 'challenges/:challengeID',
    lazy: () =>
      import('./pages/manage-challenge/ManageChallengePage').then(m => ({ Component: m.ManageChallengePage })),
  },
  {
    path: 'challenges/:challengeID/notes',
    lazy: () =>
      import('./pages/challenge-notes-list/ChallengeNotesListPage').then(m => ({
        Component: m.ChallengeNotesListPage,
      })),
  },
  {
    path: 'challenges/:challengeID/notes/create',
    lazy: () =>
      import('./pages/create-challenge-note/CreateChallengeNotePage').then(m => ({
        Component: m.CreateChallengeNotePage,
      })),
  },
  {
    path: 'challenges/:challengeID/notes/:noteID',
    lazy: () =>
      import('./pages/update-challenge-note/UpdateChallengeNotePage').then(m => ({
        Component: m.UpdateChallengeNotePage,
      })),
  },
  {
    path: 'challenges/:challengeID/tabs',
    lazy: () =>
      import('./pages/challenge-tabs-list/ChallengeTabsListPage').then(m => ({
        Component: m.ChallengeTabsListPage,
      })),
  },
  {
    path: 'challenges/:challengeID/tabs/create',
    lazy: () =>
      import('./pages/create-challenge-tab/CreateChallengeTabPage').then(m => ({
        Component: m.CreateChallengeTabPage,
      })),
  },
  {
    path: 'challenges/:challengeID/tabs/:tabID',
    lazy: () =>
      import('./pages/update-challenge-tab/UpdateChallengeTabPage').then(m => ({
        Component: m.UpdateChallengeTabPage,
      })),
  },
  {
    path: 'config',
    lazy: () => import('./pages/sandbox-config-page/SandboxConfigPage').then(m => ({ Component: m.SandboxConfigPage })),
  },
  {
    path: 'host/add',
    lazy: () => import('./pages/manage-host-page/ManageHostPage').then(m => ({ Component: m.ManageHostPage })),
  },
  {
    path: 'host/:hostType/:hostID',
    lazy: () => import('./pages/manage-host-page/ManageHostPage').then(m => ({ Component: m.ManageHostPage })),
  },
  {
    path: 'cloud/add',
    lazy: () =>
      import('./pages/manage-cloud-account-page/ManageCloudAccountPage').then(m => ({
        Component: m.ManageCloudAccountPage,
      })),
  },
  {
    path: 'cloud/:cloudAccountType/:cloudAccountID',
    lazy: () =>
      import('./pages/manage-cloud-account-page/ManageCloudAccountPage').then(m => ({
        Component: m.ManageCloudAccountPage,
      })),
  },
  {
    path: 'statistics',
    lazy: () =>
      import('./pages/track-statistics/TrackStatisticsPage').then(m => ({ Component: m.TrackStatisticsPage })),
  },
  {
    path: 'happiness',
    lazy: () => import('./pages/user-happiness/UserHappiness').then(m => ({ Component: m.UserHappiness })),
  },
  { path: 'logs', lazy: () => import('./pages/logs/Logs').then(m => ({ Component: m.Logs })) },
  {
    path: 'guidance',
    lazy: () => import('./pages/challenge-checks/ChallengeChecks').then(m => ({ Component: m.ChallengeChecks })),
  },
  {
    path: 'embed',
    lazy: () =>
      import('./pages/embed-configuration-page/EmbedConfigurationPage').then(m => ({
        Component: m.EmbedConfigurationPage,
      })),
  },

  { path: '*', element: <Navigate replace to="." /> },
];
